/**
 * @param {string[]} messages - A list of messages
 * @returns {HTMLUListElement} - An HTML element with all messages as list items
 */
export default function errorList(messages) {
	if (!Array.isArray(messages)) {
		throw new TypeError('messages is not an array')
	}

	const list = document.createElement('ul')

	messages.forEach(message => {
		if (typeof message !== 'string') {
			throw new TypeError(`message '${message}' is not a string`)
		}

		const listItem = document.createElement('li')
		listItem.textContent = message
		list.appendChild(listItem)
	})

	return list
}
